var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlixTorr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 618.28 121.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.4,106.26c1,.24,23.76,0,23.76,0L48,22.5h75.36l-3.6,16.8H62.88L38.16,121.73H0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.7 52.08 116.34 52.08 112.38 69.54 58.74 69.54 62.7 52.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.36 16.74 132.72 16.74 111.36 98.34 156.92 98.34 161.04 83.7 130.08 83.7 153.6 0 114.72 0 111.36 16.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.92 98.34 184.32 22.5 200.64 22.5 180.48 99.54 163.92 99.54 163.92 98.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "187.68 99.54 207.6 99.54 231.84 74.58 243.84 98.34 263.52 98.34 227.28 23.7 207.84 23.7 224.64 60.86 187.68 99.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.52 42.42 251.76 53.7 282 23.7 263.76 23.7 245.52 42.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "300.24 98.58 317.76 98.58 331.44 46.26 315.84 46.26 300.24 98.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "287.04 38.7 363.84 38.7 368.4 23.7 290.64 23.7 287.04 38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.64,23.7,355,98.58h76.56L451.44,23.7Zm45.6,59.52h-45.6L386.16,38.7h45.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "438.72 99.54 453.84 99.54 469.2 38.7 514.32 38.7 507.6 67.86 468.72 67.86 465.84 84.42 488.4 84.42 506.64 121.73 525.6 121.73 507.12 83.22 518.4 83.22 534.72 23.7 457.68 23.7 438.72 99.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "522.28 99.54 537.4 99.54 552.76 38.7 597.88 38.7 591.16 67.86 552.28 67.86 549.4 84.42 571.96 84.42 590.2 121.73 609.16 121.73 590.68 83.22 601.96 83.22 618.28 23.7 541.24 23.7 522.28 99.54"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlixTorr);
export default __webpack_public_path__ + "static/media/FlixTorr.785891215494ba6efdfab10b3eade420.svg";
export { ForwardRef as ReactComponent };